import { ReactNode, useMemo, useContext, createContext, useState } from "react";
import { SiteContext as SiteContextDefaultProps } from "./types";
import { FlexBox } from "@ui";
import { StaticImage } from "gatsby-plugin-image";
import { ScaleLoader } from "react-spinners";

const defaultContext: SiteContextDefaultProps = {
  siteTitle: "My Site",
  siteDescription: "My site description",
  contactOpen: false,
  setContactOpen: () => false,
  loading: false,
};

const SiteContext = createContext(defaultContext);

export const SiteContextProvider = ({ children }: { children: ReactNode }) => {
  const [loading] = useState(false);

  const [contactOpen, setContactOpen] = useState(false);
  const siteContext: SiteContextDefaultProps = useMemo(() => {
    return {
      siteTitle: "My Site",
      siteDescription: "My site description",
      contactOpen,
      setContactOpen,
      loading: loading,
    };
  }, [loading, , contactOpen]);

  if (loading) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "white",
          zIndex: 9999,
        }}
      >
        <FlexBox
          direction="column"
          align="center"
          justify="center"
          gap="30px"
          styles={{ width: "100%", height: "100%" }}
        >
          <StaticImage
            src="./images/logo.png"
            alt="Logo"
            style={{ width: "180px", height: "180px" }}
          />
          <ScaleLoader />
        </FlexBox>
      </div>
    );
  }

  return (
    <SiteContext.Provider value={siteContext}>{children}</SiteContext.Provider>
  );
};

export const useSiteContext = () => {
  return useContext(SiteContext);
};
